import { useRouteError } from "react-router";
import { useStyles } from "../../components/styles/ErrorPage.styles";

export default function ErrorPage() {
    const error = useRouteError() as Error;
    const styles = useStyles();

    return (
        <div>
            <h1 className={styles.title}>An unexpected error occurred!</h1>
            {error?.message && (
                <p className={styles.errorMessage}>
                    {error.message}
                </p>
            )}
        </div>
    );
}